import { useEffect } from 'react'
import { useThemeStore } from '@/stores/theme-store'

export function ThemeController() {
  const theme = useThemeStore((state) => state.theme)

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark')
  }, [theme])

  return null
}
